$(document).ready(function() {
  $('#home-top-banner .home-slider .banner .banner_overlay .slide_title').flowtype({
     minimum   : 768,
     minFont   : 45,
     maxFont   : 80,
     fontRatio : 6
  });
  $('#home-top-banner .home-slider .banner .banner_overlay .slide_title').flowtype({
     maximum   : 767,
     minFont   : 12,
     maxFont   : 80,
     fontRatio : 6
  });
  $('#home-int-banner1 .slide_title').flowtype({
     minFont   : 12,
     maxFont   : 80,
     fontRatio : 5.5
  });
  $('#home-int-banner3 .slide_title').flowtype({
     minFont   : 12,
     maxFont   : 80,
     fontRatio : 7.16
  });
});